import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useLocation } from "react-router-dom";
import useDynamicColors from "../../hooks/useDynamicColors";
import useClientName from "../../hooks/useClientName";
import "./style.css";

const navItems = [
  { label: "Home", icon: "home" },
  { label: "Users", icon: "users", active: true },
  { label: "Merchants", icon: "merchants" },
  { label: "Campaigns", icon: "campaigns" },
  { label: "Audits", icon: "audits" },
];

const NavIcon = ({ icon, color }) => {
  const icons = {
    home: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
    users: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    merchants: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
    campaigns: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    audits: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  };
  return icons[icon] || null;
};

const mockSteps = [
  { name: "Terms Acceptance", status: "completed", date: "2024-11-06 18:16:54", duration: "0m 35s" },
  { name: "Email Verification", status: "completed", date: "2024-11-06 18:17:29", duration: "0m 45s" },
  { name: "ID Record", status: "completed", date: "2024-11-06 18:19:14", duration: "1m 45s" },
  { name: "Selfie", status: "completed", date: "2024-11-06 18:19:49", duration: "0m 35s" },
  { name: "SMS Verification", status: "completed", date: "2024-11-06 18:22:10", duration: "2m 21s" },
  { name: "Credentials", status: "completed", date: "2024-11-06 18:22:44", duration: "0m 34s" },
];

const userInfo = [
  { icon: "mail", label: "Email", value: "ana.hurtado@email.com" },
  { icon: "phone", label: "Phone", value: "+1 555-0101" },
  { icon: "id", label: "ID Number", value: "4556789" },
  { icon: "clock", label: "Last Login", value: "2025-01-15 10:30" },
  { icon: "monitor", label: "OS", value: "Android 14" },
  { icon: "globe", label: "IP", value: "152.70.206.189" },
  { icon: "calendar", label: "Created", value: "2024-11-06" },
  { icon: "refresh", label: "Updated", value: "2025-01-15" },
];

const InfoIcon = ({ icon, color }) => {
  const size = 12;
  const icons = {
    mail: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
    phone: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
    id: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
      </svg>
    ),
    clock: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    monitor: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    globe: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    calendar: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
    refresh: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 4 23 10 17 10" />
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
      </svg>
    ),
  };
  return (
    <div
      style={{
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        backgroundColor: `${color}20`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {icons[icon] || null}
    </div>
  );
};

const ProgressBar = ({ value, max, color }) => {
  const pct = (value / max) * 100;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <div style={{ flex: 1, height: "6px", backgroundColor: "#E5E7EB", borderRadius: "3px", overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, height: "100%", backgroundColor: color, borderRadius: "3px" }} />
      </div>
      <span style={{ fontSize: "0.65rem", fontWeight: 600, color: "#374151" }}>{value}/{max}</span>
    </div>
  );
};

export const UserDetailsDashboard = () => {
  const location = useLocation();
  const clientName = useClientName();
  const colors = useDynamicColors();

  return (
    <div style={styles.laptop}>
      <div style={styles.screen}>
        <div style={styles.layout}>
          {/* Left Sidebar */}
          <div style={styles.sidebar}>
            <div style={{ textAlign: "center", padding: "16px 12px 8px" }}>
              <img
                src={
                  colors.url_logo ||
                  "https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png"
                }
                alt="Logo"
                style={{ width: "48px", height: "auto" }}
              />
              <div style={{ fontSize: "0.7rem", fontWeight: 700, color: colors.primario, marginTop: "6px" }}>
                VXApp
              </div>
            </div>
            <nav style={{ padding: "8px", display: "flex", flexDirection: "column", gap: "2px" }}>
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.active ? `/backoffice-users-${clientName}-web${location.search}` : "#"}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    fontSize: "0.7rem",
                    fontWeight: item.active ? 600 : 400,
                    color: item.active ? colors.primario : "#6B7280",
                    backgroundColor: item.active ? `${colors.primario}15` : "transparent",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                >
                  <NavIcon icon={item.icon} color={item.active ? colors.primario : colors.secundario} />
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Main area */}
          <div style={styles.mainArea}>
            {/* Top header bar */}
            <div style={{ ...styles.headerBar, backgroundColor: colors.secundario }}>
              <span style={{ fontWeight: 600, fontSize: "0.8rem" }}>User Detail</span>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ textAlign: "right", lineHeight: 1.2 }}>
                  <div style={{ fontSize: "0.65rem", opacity: 0.8 }}>User</div>
                  <div style={{ fontSize: "0.7rem", fontWeight: 600 }}>Admin</div>
                </div>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="3" />
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
              </div>
            </div>

            {/* Content area */}
            <div style={styles.contentScroll}>
              {/* Breadcrumb */}
              <div style={{ marginBottom: "12px", fontSize: "0.7rem", fontWeight: 600 }}>
                <a href={`/backoffice-users-${clientName}-web${location.search}`} style={{ color: colors.secundario, textDecoration: "none" }}>
                  Users
                </a>
                <span style={{ color: "#9CA3AF" }}> / </span>
                <span style={{ color: colors.primario }}>Ana Juliana Hurtado</span>
              </div>

              {/* User Info Card */}
              <div style={styles.userCard}>
                {/* Top row: avatar + name + disable button */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <img
                      src="/img/frame-480954771-5.png"
                      alt="Ana Juliana Hurtado"
                      style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: "cover" }}
                    />
                    <div>
                      <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#111827" }}>
                        Ana Juliana Hurtado
                      </div>
                      <span style={{
                        display: "inline-block",
                        marginTop: "4px",
                        backgroundColor: "#DEF7EC",
                        color: "#03543F",
                        padding: "1px 10px",
                        borderRadius: "12px",
                        fontSize: "0.6rem",
                        fontWeight: 500,
                      }}>
                        Approved
                      </span>
                    </div>
                  </div>
                  <button style={{
                    backgroundColor: "#EF4444",
                    color: "white",
                    border: "none",
                    padding: "5px 12px",
                    borderRadius: "6px",
                    fontSize: "0.65rem",
                    fontWeight: 500,
                    cursor: "pointer",
                    fontFamily: "Inter, sans-serif",
                  }}>
                    Disable Account
                  </button>
                </div>

                {/* Info grid */}
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  gap: "10px",
                }}>
                  {userInfo.map((item) => (
                    <div key={item.label} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <InfoIcon icon={item.icon} color={colors.terciario} />
                      <div>
                        <div style={{ fontSize: "0.55rem", color: "#9CA3AF", fontWeight: 500 }}>
                          {item.label}
                        </div>
                        <div style={{ fontSize: "0.65rem", color: "#111827", fontWeight: 500 }}>
                          {item.value}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tabs */}
              <Tabs style={{ fontWeight: 300 }}>
                <TabList>
                  <Tab>Profile</Tab>
                  <Tab>Transactions</Tab>
                  <Tab>Trades</Tab>
                  <Tab>POS</Tab>
                  <Tab>Audits</Tab>
                </TabList>

                {/* Profile tab */}
                <TabPanel>
                  <div style={{ display: "flex", gap: "12px", marginTop: "12px" }}>
                    {/* Steps section */}
                    <div style={{ flex: 1, backgroundColor: "white", borderRadius: "10px", border: "1px solid #E5E7EB", padding: "12px" }}>
                      <h3 style={{ fontSize: "0.75rem", fontWeight: 700, color: "#111827", marginBottom: "8px", margin: "0 0 8px" }}>
                        Onboarding Steps
                      </h3>
                      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.6rem" }}>
                        <thead>
                          <tr style={{ borderBottom: "1px solid #E5E7EB" }}>
                            <th style={styles.stepTh}>Step</th>
                            <th style={styles.stepTh}>Status</th>
                            <th style={styles.stepTh}>Date</th>
                            <th style={styles.stepTh}>Duration</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mockSteps.map((step) => (
                            <tr key={step.name} style={{ borderBottom: "1px solid #F3F4F6" }}>
                              <td style={styles.stepTd}>{step.name}</td>
                              <td style={styles.stepTd}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              </td>
                              <td style={{ ...styles.stepTd, color: "#6B7280" }}>{step.date}</td>
                              <td style={{ ...styles.stepTd, color: "#6B7280" }}>{step.duration}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Scores section */}
                    <div style={{ width: "200px", display: "flex", flexDirection: "column", gap: "10px" }}>
                      <div style={{ backgroundColor: "white", borderRadius: "10px", border: "1px solid #E5E7EB", padding: "12px" }}>
                        <h4 style={{ fontSize: "0.65rem", fontWeight: 600, color: "#111827", margin: "0 0 8px" }}>
                          Document Score
                        </h4>
                        <ProgressBar value={95} max={100} color="#10B981" />
                      </div>
                      <div style={{ backgroundColor: "white", borderRadius: "10px", border: "1px solid #E5E7EB", padding: "12px" }}>
                        <h4 style={{ fontSize: "0.65rem", fontWeight: 600, color: "#111827", margin: "0 0 8px" }}>
                          Biometric Score
                        </h4>
                        <ProgressBar value={88} max={100} color="#10B981" />
                      </div>
                    </div>
                  </div>
                </TabPanel>

                {/* Other tabs */}
                <TabPanel>
                  <div style={styles.emptyTab}>
                    <p style={{ color: "#9CA3AF", fontSize: "0.75rem" }}>Transactions content</p>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div style={styles.emptyTab}>
                    <p style={{ color: "#9CA3AF", fontSize: "0.75rem" }}>Trades content</p>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div style={styles.emptyTab}>
                    <p style={{ color: "#9CA3AF", fontSize: "0.75rem" }}>POS content</p>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div style={styles.emptyTab}>
                    <p style={{ color: "#9CA3AF", fontSize: "0.75rem" }}>Audits content</p>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <div style={styles.base}></div>
    </div>
  );
};

const styles = {
  laptop: {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "10px",
    width: "960px",
    height: "500px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  },
  screen: {
    backgroundColor: "white",
    borderRadius: "5px",
    overflow: "hidden",
    width: "100%",
    height: "500px",
  },
  layout: {
    display: "flex",
    height: "100%",
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
  },
  sidebar: {
    width: "170px",
    minWidth: "170px",
    backgroundColor: "#FFFFFF",
    borderRight: "1px solid #E5E7EB",
    display: "flex",
    flexDirection: "column",
  },
  mainArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#F3F4F6",
    overflow: "hidden",
  },
  headerBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 16px",
    color: "white",
  },
  contentScroll: {
    flex: 1,
    overflowY: "auto",
    padding: "16px",
  },
  userCard: {
    backgroundColor: "white",
    borderRadius: "10px",
    border: "1px solid #E5E7EB",
    padding: "14px",
    marginBottom: "12px",
  },
  stepTh: {
    padding: "6px 8px",
    textAlign: "left",
    fontWeight: 500,
    color: "#6B7280",
    fontSize: "0.6rem",
  },
  stepTd: {
    padding: "6px 8px",
    fontSize: "0.6rem",
    color: "#111827",
  },
  emptyTab: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "120px",
  },
  base: {
    position: "absolute",
    width: "1100px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  },
};
